<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Клиенты(черновики)
      </h1>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-if="drafts.length > 0"
        :items="drafts"
        :headers="headers"
        hide-actions
        :pagination.sync="pagination"
        :rows-per-page-items="[13]"
        class="elevation-1 mb-1 table-striped"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr
            class="clickable-row"
            @click="
              $router.push({
                name: 'clientDraft',
                params: { id: props.item.Id }
              })
            "
          >
            <td :class="{ 'red lighten-4': props.item.Title === '' }">
              {{ props.item.Title }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="pagination.page"
          :length="pages"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getAllClientDrafts } from "../../../backend/importApi.js";

export default {
  data() {
    return {
      drafts: [],
      headers: [{ text: "Название клиента", sortable: false }],
      pagination: {},
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage,
      );
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.drafts = await getAllClientDrafts();
    },
  },
};
</script>
